<template>
  <div class="app-container">
    <!-- 顶部菜单栏 -->
    <TopMenu />
    
    <div class="main-content">
      <!-- 左侧菜单栏 -->
      <SideMenu @menu-click="handleMenuClick" />
      
      <!-- 右侧动态内容 -->
      <div class="content-area">
        <DynamicContent :component="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import TopMenu from '../components/TopMenu.vue'
import SideMenu from '../components/SideMenu.vue'
import DynamicContent from '../components/DynamicContent.vue'
import IndexView from './IndexView.vue'

export default {
  components: {
    TopMenu,
    SideMenu,
    DynamicContent
  },
  setup() {
    const currentComponent = ref(IndexView)
    
    const handleMenuClick = (component) => {
      currentComponent.value = component
    }
    
    return {
      currentComponent,
      handleMenuClick
    }
  }
}
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.content-area {
  flex: 1;
  width:85%;
  overflow-y: auto;
  background-color: #f5f5f5;
}
</style>